<template>
  <div>
    <template v-if="!isJustSubtitles">
      <v-card-text
        class="pt-1 pb-0"
        v-if="
          isJustLinks === true &&
            structuredData.links &&
            (isPopup || showLinks['links'])
        "
      >
        <p
          v-show="!isPopup"
          v-for="(link, index) in structuredData.links"
          :key="`${viewType}_links_p2_${index}`"
          class="pa-0 ma-0 "
          style="  line-height: 1.3;"
        >
          <a
            v-show="link.url"
            :href="link.url"
            target="_blank"
            style="text-decoratin: underline!important;"
            class="primary--text"
            >{{ link.title ? link.title : link.url }}</a
          >
        </p>

        <p
          v-show="isPopup"
          v-for="(link, index) in structuredData.links"
          :key="`${viewType}_links_${index}`"
          class="pa-0 ma-1 "
        >
          <a
            v-show="link.url"
            :href="link.url"
            target="_blank"
            style="text-decoratin: underline!important;"
            class="primary--text"
            >{{ link.title ? link.title : link.url }}</a
          >
        </p>
      </v-card-text>

      <v-card-text
        v-if="
          structuredData.downloadAssets &&
            (!isPopup || showLinks['downloadAssets'])
        "
      >
        <span class="font-weight-medium   headingText">
          Documents:
        </span>
        <p
          v-for="(link, index) in structuredData.downloadAssets"
          :key="`${viewType}_docs_${index}`"
          class="pa-0 ma-1 "
        >
          <a
            :href="link.url"
            target="_blank"
            style="text-decoration: underline!important;"
            class="primary--text"
          >
            {{ link.title }}
          </a>
        </p>
      </v-card-text>

      <v-card-text
        v-if="
          showEvent &&
            postId &&
            !isJustSubtitles &&
            !isPopup &&
            eventsFormated &&
            postId &&
            eventsFormated[postId]
        "
      >
        <eventTimeline
          ref="timelineUi"
          :eventsFormated="eventsFormated"
          :postId="postId"
          v-if="postId"
        >
        </eventTimeline>
      </v-card-text>

      <v-card-text
        class="pt-1 pb-1"
        v-if="
          isJustLinks === true &&
            structuredData.socialmedia &&
            (!isPopup || showLinks['socialmedia'])
        "
      >
        <span v-if="false" class="text-h5 text--darken-1 ">Social media: </span>

        <div>
          <v-btn
            v-for="(link, index) in structuredData.socialmedia"
            :key="`${viewType}_socialmedia_${index}`"
            small
            fab
            elevation="0"
            :href="link.url"
            :title="`${link.title}:  ${link.url}`"
            target="_blank"
            class="mx-0 px-0"
            color="white"
          >
            <v-icon
              class="mx-0 px-0"
              :xcolor="appSettings.socialIcon[link.title].color"
              color="#394049"
            >
              {{ appSettings.socialIcon[link.title].icon }}</v-icon
            >
          </v-btn>
        </div>
        <div v-if="false">
          <v-btn
            v-for="(link, index) in structuredData.socialmedia"
            :key="`${viewType}_socialmedia_${index}`"
            light
            fab
            small
            :href="link.url"
            target="_blank"
            class="mx-1"
          >
            <v-icon :color="appSettings.socialIcon[link.title].color">{{
              appSettings.socialIcon[link.title].icon
            }}</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </template>
  </div>
</template>

<script>
import eventTimeline from "./../ui/eventTimeline.vue";

export default {
  name: "extraInfoBlocks",
  props: {
    appSettings: Object,
    location: Object,
    media: Array,
    functions: Object,
    properties: Object,
    structuredData: Object,
    eventsFormated: Object,
    postId: Number,
    Point_Name: String,
    Site_Marker_Number: String,
    isPopup: {
      type: Boolean,
      default: false
    },
    isJustSubtitles: {
      type: Boolean,
      default: false
    },
    isJustLinks: {
      type: Boolean,
      default: false
    }
  },
  components: {
    eventTimeline
  },
  data: () => ({
    showEvent: true,
    viewType: "moreInfo", //popup
    showMore: false,
    descriptionCropLength: 200
  }),
  watch: {
    postId: function() {
      try {
        this.$refs.timelineUi.contractView();
      } catch (e) {
        //do nothing;
      }
    }
  },
  computed: {
    buttonWidth() {
      if (this.isPopup === true) {
        return this.appSettings.popupButtonWidth;
      } else {
        let value = this.$vuetify.breakpoint.smAndUp
          ? this.appSettings.drawWidth
          : this.appSettings.mobDrawWidth;

        value = parseFloat(value) - 30;
        return `${value}px`;
      }
    },
    onlyShow() {
      return this.isJustSubtitles ? ["subtitle"] : [];
    },
    orderedItems() {
      let items = [];
      let orderedItems = {};
      //onlyShow

      let sideBarExclude = this.isPopup ? [] : ["subtitle"];
      let popUpExclude = this.isPopup ? [] : [];
      let exclude = [
        "links",
        "download",
        "socialmedia",
        ...sideBarExclude,
        ...popUpExclude
      ];

      let length = 0;
      for (var sectionKey in this.structuredData) {
        let sectionSet = this.structuredData[sectionKey];
        if (
          (this.isJustSubtitles && this.onlyShow.includes(sectionKey)) ||
          (!this.isJustSubtitles && !exclude.includes(sectionKey))
        ) {
          for (var fieldKey in sectionSet) {
            let fieldValue = sectionSet[fieldKey];

            if (
              (this.isPopup === true && fieldValue.showInPopUp) ||
              (this.isPopup === true &&
                !fieldValue.hideInPopUp &&
                sectionKey === "subtitle") ||
              (this.isPopup !== true && !fieldValue.hideInSiteInfo)
            ) {
              orderedItems[fieldValue.order] = fieldValue;
              length = length < fieldValue.order ? fieldValue.order : length;
            }
          }
        }
      }

      for (let index = 0; index <= length; index++) {
        if (
          orderedItems[index] &&
          orderedItems[index].sectionKey === "subtitle"
        ) {
          items.push(orderedItems[index]);
        }
      }

      if (
        this.media &&
        this.media.length &&
        (this.isPopup || !this.isJustSubtitles)
      ) {
        items.push({
          sectionKey: "gallerybutton",
          value: true
        });
      }

      for (let index = 0; index <= length; index++) {
        if (
          orderedItems[index] &&
          orderedItems[index].sectionKey !== "subtitle"
        ) {
          items.push(orderedItems[index]);
        }
      }

      return items;
    },

    showLinks() {
      if (!this.isPopup) {
        return {
          links: true,
          downloadAssets: true,
          socialmedia: true
        };
      } else {
        //if any of these sections have any showInPopUp the section gets shown.
        let values = {
          links: false,
          downloadAssets: false,
          socialmedia: false
        };
        let popUpChecks = { links: true, download: true, socialmedia: true };
        for (var sectionKey in popUpChecks) {
          let sectionSet = this.structuredData[sectionKey];
          for (var fieldKey in sectionSet) {
            let fieldValue = sectionSet[fieldKey];
            if (fieldValue.showInPopUp) {
              values[sectionKey] = true;
            }
          }
        }
        return values;
      }
    }
  },
  methods: {
    //do nothing
  }
};
</script>
<style>
div {
  color: "#1e2245";
  color: "#394049";
  color: "#448532";
  color: "#1e2245";
}

.M_TA_Timeline .textareaAct {
  xxfont-weight: 500;
}
</style>
